// extracted by mini-css-extract-plugin
module.exports = {"makeOrderContainer":"makeOrder_makeOrderContainer__3SJep","approvePopupContainer":"makeOrder_approvePopupContainer__2tTDG","popupTextArea":"makeOrder_popupTextArea__qIMOg"};